import React from "react";

const ErrorIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7679 0.767877C10.7916 -0.208434 9.20865 -0.208432 8.23234 0.767878L0.767877 8.23234C-0.208434 9.20865 -0.208432 10.7916 0.767878 11.7679L8.23234 19.2323C9.20865 20.2087 10.7916 20.2087 11.7679 19.2323L19.2323 11.7679C20.2087 10.7916 20.2087 9.20865 19.2323 8.23234L11.7679 0.767877ZM9.00005 6.00011C9.00005 5.44782 9.44776 5.00011 10 5.00011C10.5523 5.00011 11 5.44782 11 6.00011V10.0001C11 10.5524 10.5523 11.0001 10 11.0001C9.44776 11.0001 9.00005 10.5524 9.00005 10.0001V6.00011ZM11 14.0001C11 14.5524 10.5523 15.0001 10 15.0001C9.44776 15.0001 9.00005 14.5524 9.00005 14.0001C9.00005 13.4478 9.44776 13.0001 10 13.0001C10.5523 13.0001 11 13.4478 11 14.0001Z"
        fill="#D72C0D"
      />
    </svg>
  );
};

export default ErrorIcon;
